import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  size?: 'default' | 'large';
}
export function CTAButton({
  children,
  onClick,
  className = '',
  size = 'default'
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-12 py-5 text-xl' : 'px-8 py-4 text-lg';
  return <motion.button onClick={onClick} className={`
        ${sizeClasses}
        bg-accent-bronze hover:bg-accent-gold
        text-bg-primary font-heading font-bold
        rounded-sm
        transition-colors duration-300
        shadow-lg hover:shadow-xl
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.2
  }} data-id="element-25">
      {children}
    </motion.button>;
}